// Forked from ../../RecentSearches/RecentSearches.tsx — keep in sync until phase_0 cleanup.
import React from 'react';
import styled from 'styled-components';
import { useTranslate } from '@bynder/localization';
import { List, token } from '@bynder/design-system';
import { useSelectRecentSearch } from '../../hooks/useSelectRecentSearch';
import { RecentSearchItem } from './RecentSearchItem';
import { useSearch } from '../../SpotlightState';

export default function RecentSearches() {
	const { recentSearchTerms } = useSearch();
	const { translate } = useTranslate();
	const handleSearch = useSelectRecentSearch();

	if (recentSearchTerms.length === 0) {
		return null;
	}

	return (
		<StyledSection>
			<StyledHeading>{translate('spotlightHelp.recentSearchesRedesign')}</StyledHeading>
			<List isContained>
				<ul>
					{recentSearchTerms.map((term: string) => (
						<RecentSearchItem
							term={term}
							onSelect={() => handleSearch(term)}
							key={term}
						/>
					))}
				</ul>
			</List>
		</StyledSection>
	);
}

const StyledSection = styled.div`
	display: flex;
	flex-direction: column;
`;

const StyledHeading = styled.div`
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	color: ${token.colorTextMuted};
	padding: 0 ${token.spacing5} ${token.spacing3};
`;
